export default __webpack_public_path__ + "3bde51cb9900b31ed4eabaef900dd6ab.svg";